import { render, staticRenderFns } from "./SelectedCompanies.vue?vue&type=template&id=3306c5d4&"
import script from "./SelectedCompanies.vue?vue&type=script&lang=js&"
export * from "./SelectedCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports